import { ComponentStyleConfig } from '@chakra-ui/react';

export const text: ComponentStyleConfig = {
  baseStyle: {
    color: 'text.main',
  },
  variants: {
    tabContentTitle: {
      fontWeight: 'bold',
    },
  },
};
